/**
 * 角色
 */
export type RoleId = string;
export type RoleNo = number;

export enum RoleType {
    /** 内部角色 */
    internal = 0,
    /** 外部角色 */
    external = 1,
    /** 互联组织角色 */
    corp_coop = 2
}

export enum RoleStatus {
    active = 1,
    dismission = -1
}

/**
 * 角色或角色组来源
 */
export enum RoleSource {
    default = 'internal',
    integrate = 'sync'
}

/**
 * 角色/角色组过滤规则
 */
export enum RoleOrGroupFilterType {
    /** 仅同步 */
    sync_only = 'sync_only',
    /** 仅自建 */
    internal_only = 'internal_only',
    /** 同步 & 自建 */
    all = 'all'
}

export interface IRole {
    /** 角色 Id */
    _id: RoleId;
    /** 角色编号 */
    role_no: RoleNo;
    /** 角色名称 */
    name: string;
    /** 角色类型 */
    type: RoleType;
    /** 角色来源 */
    source: RoleSource;
    /** 角色状态 */
    status?: RoleStatus;
    /** 排序顺序 */
    seq?: number;

    /** 角色组编号 */
    group_no?: RoleGroupNo;
    group_name?: string;

    /** 是否可管理 */
    editable?: boolean;

    // 兼容结构(暂存)
    // role_id: RoleNo;
    // group_id: RoleGroupNo
}

/**
 * 角色组
 */
export type RoleGroupId = string;
export type RoleGroupNo = number;

export interface IRoleGroup {
    /** 角色组 Id */
    _id: RoleGroupId;
    /** 角色组编号 */
    group_no: RoleGroupNo;
    /** 角色组名称 */
    name: string;
    /** 角色组类型 */
    type: RoleType;
    /** 序号 */
    seq: number;
    source: RoleSource; // 角色来源
    /** 是否可管理 */
    editable?: boolean;

    // 兼容结构(暂存)
    // group_id: RoleGroupNo
}

export interface ContactRoleInfo {
    /** 是否拥有全部角色写权限 */
    has_full_writable_permission: boolean;
    /** 是否拥有全部角色读权限 */
    has_full_readable_permission: boolean;
    roles: IRole[];
    role_groups?: IRoleGroup[];
    count?: number;
}
